import { render, staticRenderFns } from "./customerNSales1.vue?vue&type=template&id=39f8ede8"
import script from "./customerNSales1.vue?vue&type=script&lang=js"
export * from "./customerNSales1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports